import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function loginToStripe() {
  const res = await fetchOrchidAPI("/api/users/v1/orchid_pro/stripe_login_url");
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return res.json();
}
